export default __webpack_public_path__ + "static/media/documentsneeded.43ef2b92.jpg";